import { useState } from "react";
import WorldMpProvider from "@/core/data-provider/data-mp/world/world-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useServerIsoTime() {
  const [timeDiff, setTimeDiff] = useState<number | null>(null);
  const [timeZone, setTimeZone] = useState<string | null>(null);

  const getIsoTime = (timestampMs: number): string => {
    const date = new Date(timestampMs);

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hour = String(date.getUTCHours()).padStart(2, "0");
    const minute = String(date.getUTCMinutes()).padStart(2, "0");
    const second = String(date.getUTCSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hour}:${minute}:${second}.000Z`;
  };

  const fetchServerTimeIso = async (): Promise<string | null> => {
    const storedDiffStr = sessionStorage.getItem("timeDiff");
    const storedZone = sessionStorage.getItem("timeZone");

    const storedDiff = storedDiffStr ? Number(storedDiffStr) : null;

    if (storedDiff !== null && storedZone) {
      setTimeDiff(storedDiff);
      setTimeZone(storedZone);
      return getIsoTime(Date.now() + storedDiff * 1000);
    }

    try {
      const response = await WorldMpProvider.getWorldTime();
      if (response instanceof RpcMpProviderSuccessResponse) {
        const serverData = response.data.server;
        const diff = serverData.timestamp - Math.floor(Date.now() / 1000);
        const tz = serverData.timezone;

        sessionStorage.setItem("timeDiff", diff.toString());
        sessionStorage.setItem("timeZone", tz);

        setTimeDiff(diff);
        setTimeZone(tz);

        return getIsoTime(serverData.timestamp * 1000);
      }
    } catch (e) {
      console.error("Failed to fetch server time:", e);
    }

    return null;
  };

  return { fetchServerTimeIso, timeDiff, timeZone };
}
